import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import styles from "./index.module.css";

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";

import * as ajax from "helpers/ajax";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import ProgressBar from "@ramonak/react-progress-bar";
import { toPercentage, calculateSALHierarchical } from "helpers/functions.js"
import { isAccordoQuadro } from "helpers/functions.js"
import { ROLES } from "constant"



export default class SALCommessa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            salList: [],
            search:"",
            expandedItems: {},
            contextMenu: null,
            selectedSAL: null,
        };

    }

    componentDidMount = () => {
        this.load()
    }

    load = () => {
        let url = "sal-commessas?filters[commessa][id][$eq]=" + this.state.data.id + "&sort[0]=order:asc&sort[1]=createdAt:asc&populate=parent";
        ajax.ajaxGetStrapi(url, this.loadCallback)
    }

    loadCallback = (response) => {
        // Just store the raw data, let the global function handle hierarchy
        this.setState({ salList: response.data }, () => {
            // Dopo aver caricato i dati, inizializza i valori di order mancanti
            this.initializeMissingOrders();
        });
    }

    initializeMissingOrders = async () => {
        const salList = this.state.salList;
        const updatesNeeded = [];
        
        // Raggruppa SAL per parent (stesso livello)
        const salsByParent = {};
        salList.forEach(sal => {
            const parentKey = sal.parent?.id || 'root';
            if (!salsByParent[parentKey]) {
                salsByParent[parentKey] = [];
            }
            salsByParent[parentKey].push(sal);
        });

        // Per ogni gruppo, verifica e assegna ordini mancanti/duplicati
        Object.keys(salsByParent).forEach(parentKey => {
            const siblings = salsByParent[parentKey];
            
            // Ordina per order esistente e createdAt
            siblings.sort((a, b) => {
                const orderA = a.order || 0;
                const orderB = b.order || 0;
                if (orderA === orderB) {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                }
                return orderA - orderB;
            });

            // Controlla se ci sono valori duplicati o mancanti
            const orderValues = siblings.map(s => s.order || 0);
            const hasDuplicates = orderValues.some((val, index) => orderValues.indexOf(val) !== index);
            const hasMissing = siblings.some(s => !s.order || s.order === 0);
            
            // Se ci sono duplicati o valori mancanti, riassegna tutti gli ordini
            if (hasDuplicates || hasMissing) {
                siblings.forEach((sal, index) => {
                    const newOrder = (index + 1) * 10;
                    if (sal.order !== newOrder) {
                        updatesNeeded.push({
                            id: sal.id,
                            order: newOrder
                        });
                    }
                });
            }
        });

        // Esegui gli aggiornamenti se necessari
        if (updatesNeeded.length > 0) {
            await this.batchUpdateOrders(updatesNeeded);
        }
    }

    batchUpdateOrders = async (updates) => {
        try {
            const promises = updates.map(update => 
                new Promise((resolve, reject) => {
                    const formData = { data: { order: update.order } };
                    ajax.ajaxPutStrapi(`sal-commessas/${update.id}`, formData, 
                        (response) => resolve(response),
                        (error) => reject(error)
                    );
                })
            );

            await Promise.all(promises);
            
            // Ricarica i dati dopo l'aggiornamento
            this.load();
        } catch (error) {
            console.error('Errore durante l\'inizializzazione degli ordini:', error);
        }
    }

    // Keep only the display organization for rendering hierarchy
    organizeSALHierarchy = (salList) => {
        const salMap = {};
        const rootSALs = [];

        // Create a map of all SALs
        salList.forEach(sal => {
            salMap[sal.id] = { ...sal, children: [] };
        });

        // Organize into hierarchy and sort children
        salList.forEach(sal => {
            if (sal.parent && sal.parent.id && salMap[sal.parent.id]) {
                salMap[sal.parent.id].children.push(salMap[sal.id]);
            } else {
                rootSALs.push(salMap[sal.id]);
            }
        });

        // Sort all levels by order (or createdAt if order is null/0)
        const sortSALs = (salArray) => {
            salArray.sort((a, b) => {
                const orderA = a.order || 0;
                const orderB = b.order || 0;
                if (orderA === orderB) {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                }
                return orderA - orderB;
            });

            // Recursively sort children
            salArray.forEach(sal => {
                if (sal.children && sal.children.length > 0) {
                    sortSALs(sal.children);
                }
            });
        };

        sortSALs(rootSALs);

        // Calculate parent values using the same logic as global function
        this.calculateParentValues(rootSALs);
        
        // Generate hierarchical IDs for display only
        this.generateHierarchicalIds(rootSALs);

        return rootSALs;
    }

    calculateParentValues = (salList) => {
        salList.forEach(sal => {
            if (sal.children && sal.children.length > 0) {
                // First calculate for children recursively
                this.calculateParentValues(sal.children);
                
                // For parents: calculate values from direct children only
                let totalWeightedPercentage = 0;
                let totalIncidenza = 0;
                
                sal.children.forEach(child => {
                    const childIncidenza = child.incidenza || 0;
                    const childPercentage = child.percentage || 0;
                    totalWeightedPercentage += (childPercentage * childIncidenza);
                    totalIncidenza += childIncidenza;
                });
                
                // Parent's incidenza is sum of direct children's incidences
                sal.incidenza = totalIncidenza;
                
                // Parent's percentage is weighted average of direct children
                if (totalIncidenza > 0) {
                    sal.percentage = Math.round(totalWeightedPercentage / totalIncidenza);
                    sal.completed = sal.percentage >= 100;
                } else {
                    sal.percentage = 0;
                    sal.completed = false;
                }
            }
        });
    }

    // Keep only for display purposes
    generateHierarchicalIds = (salList, parentId = "") => {
        salList.forEach((sal, index) => {
            if (parentId === "") {
                sal.hierarchicalId = (index + 1).toString();
            } else {
                sal.hierarchicalId = `${parentId}.${index + 1}`;
            }

            if (sal.children && sal.children.length > 0) {
                this.generateHierarchicalIds(sal.children, sal.hierarchicalId);
            }
        });
    }

    setComplete = (val, id, key) => {
        if (key == "percentage") {
            if (val >= 100) { val = 100; this.setComplete(true, id, "completed") } else { this.setComplete(false, id, "completed") }
            if (val < 0 || !val) { val = 0 }
        }
        if (key == "incidenza") {
            if (val < 0 || !val) { val = null }
        }

        let data = {}
        data[key] = val;

        let formData = { "data": data };
        ajax.ajaxPutStrapi("sal-commessas/"+id, formData, this.load)
    }

    editSAL = (id, oldValue) => {
        let val = prompt("Modifica attività", oldValue);

        if (!val) { return }

        let data = {
            "nome": val
        }
        let formData = { "data": data };
        ajax.ajaxPutStrapi("sal-commessas/" + id, formData, this.load)

    }

    deleteSAL = (id) => {
        ajax.ajaxDeleteStrapi("sal-commessas/" + id, this.load)
    }

    createNewSAL = (parentId = null) => {
        let nome = prompt("Inserisci nome attività");
        
        if (!nome) { return }

        // Calcola il prossimo ordine disponibile per questo livello
        const siblings = this.state.salList.filter(sal => {
            const salParentId = sal.parent?.id || null;
            return salParentId === parentId;
        });
        
        const maxOrder = siblings.length > 0 
            ? Math.max(...siblings.map(s => s.order || 0))
            : 0;
        
        const newOrder = maxOrder + 10;

        let data = {
            "nome": nome,
            "commessa": this.state.data.id,
            "percentage": 0,
            "completed": false,
            "incidenza": null,
            "order": newOrder
        };

        if (parentId) {
            data.parent = parentId;
        }

        let formData = { "data": data };
        ajax.ajaxPostStrapi("sal-commessas", formData, this.load);
    }

    toggleExpanded = (salId) => {
        this.setState(prevState => ({
            expandedItems: {
                ...prevState.expandedItems,
                [salId]: !prevState.expandedItems[salId]
            }
        }));
    }

    handleContextMenu = (event, sal) => {
        event.preventDefault();
        if (this.state.data.stato === "finito" || [ROLES.segreteria].includes(global.user.ruolo)) {
            return;
        }
        
        this.setState({
            contextMenu: {
                mouseX: event.clientX - 2,
                mouseY: event.clientY - 4,
            },
            selectedSAL: sal,
        });
    }

    handleCloseContextMenu = () => {
        this.setState({
            contextMenu: null,
            selectedSAL: null,
        });
    }

    moveUp = () => {
        const sal = this.state.selectedSAL;
        if (!sal) return;
        
        // Trova tutti i SAL dello stesso livello (stesso parent)
        const siblings = this.getSiblings(sal);
        const currentIndex = siblings.findIndex(s => s.id === sal.id);
        
        if (currentIndex > 0) {
            // Scambia l'ordine con l'elemento precedente
            this.swapOrders(siblings[currentIndex], siblings[currentIndex - 1]);
        }
        
        this.handleCloseContextMenu();
    }

    moveDown = () => {
        const sal = this.state.selectedSAL;
        if (!sal) return;
        
        const siblings = this.getSiblings(sal);
        const currentIndex = siblings.findIndex(s => s.id === sal.id);
        
        if (currentIndex < siblings.length - 1) {
            // Scambia l'ordine con l'elemento successivo
            this.swapOrders(siblings[currentIndex], siblings[currentIndex + 1]);
        }
        
        this.handleCloseContextMenu();
    }

    moveToTop = () => {
        const sal = this.state.selectedSAL;
        if (!sal) return;
        
        const siblings = this.getSiblings(sal);
        const orders = siblings.map(s => s.order || 0).filter(o => o > 0);
        const minOrder = orders.length > 0 ? Math.min(...orders) : 10;
        
        // Assegna un ordine minore del minimo attuale
        this.updateSALOrder(sal.id, Math.max(1, minOrder - 10));
        
        this.handleCloseContextMenu();
    }

    moveToBottom = () => {
        const sal = this.state.selectedSAL;
        if (!sal) return;
        
        const siblings = this.getSiblings(sal);
        const orders = siblings.map(s => s.order || 0);
        const maxOrder = Math.max(...orders, 0);
        
        // Assegna un ordine maggiore del massimo attuale
        this.updateSALOrder(sal.id, maxOrder + 10);
        
        this.handleCloseContextMenu();
    }

    increaseLevel = () => {
        const sal = this.state.selectedSAL;
        if (!sal) return;
        
        // Trova il parent del parent (nonno)
        let newParentId = null;
        if (sal.parent && sal.parent.id) {
            const currentParent = this.state.salList.find(s => s.id === sal.parent.id);
            if (currentParent && currentParent.parent && currentParent.parent.id) {
                newParentId = currentParent.parent.id;
            }
        }
        
        // Calcola il nuovo ordine per il nuovo livello
        const newSiblings = this.state.salList.filter(s => {
            const sParentId = s.parent?.id || null;
            return sParentId === newParentId && s.id !== sal.id;
        });
        
        const maxOrder = newSiblings.length > 0 
            ? Math.max(...newSiblings.map(s => s.order || 0))
            : 0;
        
        const newOrder = maxOrder + 10;
        
        // Aggiorna sia il parent che l'order
        const data = { 
            parent: newParentId,
            order: newOrder
        };
        const formData = { data };
        ajax.ajaxPutStrapi(`sal-commessas/${sal.id}`, formData, this.load);
        
        this.handleCloseContextMenu();
    }

    getSiblings = (sal) => {
        const parentId = sal.parent?.id || null;
        return this.state.salList.filter(s => {
            const sParentId = s.parent?.id || null;
            return sParentId === parentId;
        }).sort((a, b) => {
            // Tratta i valori null/undefined come 0
            const orderA = a.order || 0;
            const orderB = b.order || 0;
            if (orderA === orderB) {
                return new Date(a.createdAt) - new Date(b.createdAt);
            }
            return orderA - orderB;
        });
    }

    swapOrders = (sal1, sal2) => {
        const order1 = sal1.order || 0;
        const order2 = sal2.order || 0;
        
        // Se entrambi hanno order 0, assegna valori sequenziali
        if (order1 === 0 && order2 === 0) {
            this.updateSALOrder(sal1.id, 20);
            this.updateSALOrder(sal2.id, 10);
        } else if (order1 === 0) {
            this.updateSALOrder(sal1.id, order2);
            this.updateSALOrder(sal2.id, order2 - 5);
        } else if (order2 === 0) {
            this.updateSALOrder(sal2.id, order1);
            this.updateSALOrder(sal1.id, order1 + 5);
        } else {
            this.updateSALOrder(sal1.id, order2);
            this.updateSALOrder(sal2.id, order1);
        }
    }

    updateSALOrder = (salId, newOrder) => {
        const formData = { data: { order: newOrder } };
        ajax.ajaxPutStrapi(`sal-commessas/${salId}`, formData, this.load);
    }

    renderSALRecursive = (sal, index, level = 0, parentId = null) => {
        const items = [];
        
        if (!(sal.nome.toUpperCase()).includes(this.state.search.toUpperCase())) {
            // If parent doesn't match search, still check children
            if (sal.children && sal.children.length > 0) {
                sal.children.forEach((child, childIndex) => {
                    items.push(...this.renderSALRecursive(child, childIndex, level + 1, sal.id));
                });
            }
            return items;
        }

        const hasChildren = sal.children && sal.children.length > 0;
        const isExpanded = this.state.expandedItems[sal.id] !== false; // Default to expanded
        const canMove = this.state.data.stato !== "finito" && ![ROLES.segreteria].includes(global.user.ruolo);

        const salContent = (
            <Grid 
                container 
                alignItems="center" 
                sx={{ 
                    borderBottom: "1px solid #00000080", 
                    marginBottom: "15px", 
                    paddingBottom: "15px",
                    paddingTop: "5px",
                    cursor: canMove ? 'context-menu' : 'default',
                    transition: 'background-color 0.2s',
                    '&:hover': canMove ? { backgroundColor: '#f8f9fa' } : {}
                }}
                onContextMenu={(e) => this.handleContextMenu(e, sal)}
            >
                <Grid item sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                    {canMove && (
                        <Icon sx={{ marginRight: '8px', color: '#666' }}>
                            more_vert
                        </Icon>
                    )}
                    {hasChildren && (
                        <Icon 
                            sx={{ 
                                cursor: 'pointer', 
                                marginRight: '8px',
                                transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                transition: 'transform 0.2s'
                            }}
                            onClick={() => this.toggleExpanded(sal.id)}
                        >
                            chevron_right
                        </Icon>
                    )}
                    <MDTypography variant="button" fontWeight="bold">
                        {sal.hierarchicalId}
                    </MDTypography>
                </Grid>

                <Grid item sm={3} >
                    <MDTypography variant="button" sx={{ textDecoration: (sal.completed) ? 'line-through' : 'none' }}>
                        {sal.nome}
                    </MDTypography>
                </Grid>

                {!hasChildren && (
                    <>
                        <Grid item sm={1} mr={1}>
                            <MDInput 
                                disabled={this.state.data.stato == "finito"?true:false} 
                                variant="outlined" 
                                key={new Date()+index} 
                                type={"number"} 
                                defaultValue={sal.incidenza} 
                                onBlur={(e) => this.setComplete(e.target.value, sal.id, "incidenza")}  
                            />
                        </Grid>

                        <Grid item sm={2} mr={1}>
                            <MDInput 
                                disabled={this.state.data.stato == "finito" ? true : false} 
                                variant="outlined" 
                                defaultValue={sal.percentage} 
                                type={"number"} 
                                onBlur={(e) => this.setComplete(e.target.value, sal.id, "percentage")} 
                            />
                        </Grid>
                    </>
                )}

                {hasChildren && (
                    <>
                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="caption">
                                {sal.incidenza || 0}
                            </MDTypography>
                        </Grid>

                        <Grid item sm={2} mr={1}>
                            <MDTypography variant="caption">
                                {sal.percentage || 0}%
                            </MDTypography>
                        </Grid>
                    </>
                )}

                <Grid item style={{ flex: 1 }} pr={2}>
                    {this.renderProgressBar(sal.percentage?sal.percentage:0)}
                </Grid>

                {[ROLES.segreteria].includes(global.user.ruolo) || this.state.data.stato=="finito" ? null :
                    <>
                        {level < 999 && (
                            <Grid item mr={1}>
                                <MDButton variant="gradient" color="info" iconOnly onClick={() => this.createNewSAL(sal.id)}>
                                    <Icon>add_circle</Icon>
                                </MDButton>
                            </Grid>
                        )}
                        <Grid item mr={1}>
                            <MDButton variant="gradient" color="warning" iconOnly onClick={() => this.editSAL(sal.id, sal.nome)}>
                                <Icon>edit</Icon>
                            </MDButton>
                        </Grid>
                        <Grid>
                            <MDButton variant="gradient" color="error" iconOnly onClick={() => this.deleteSAL(sal.id)}>
                                <Icon>delete</Icon>
                            </MDButton>
                        </Grid>
                    </>
                }
            </Grid>
        );

        items.push(
            <div key={"sal-" + sal.id + "-" + level + "-" + index}>
                {salContent}
            </div>
        );

        // Render children separately to avoid nested borders, only if expanded
        if (hasChildren && isExpanded) {
            sal.children.forEach((child, childIndex) => {
                items.push(...this.renderSALRecursive(child, childIndex, level + 1, sal.id));
            });
        }

        return items;
    }

    renderSAL = (el, index) => {
        return this.renderSALRecursive(el, index, 0);
    }

    renderSALList = (organizedForDisplay) => {
        return (
            <div>
                {organizedForDisplay.map((el, index) => {
                    return this.renderSAL(el, index);
                })}
            </div>
        );
    }

    renderProgressBar = (percentage) => {
        return (
            <ProgressBar className={styles.progressBar} completed={percentage} customLabel={toPercentage(percentage)} />
            )
    }

    render() {
        const organizedForDisplay = this.organizeSALHierarchy(this.state.salList);
        
        const globalCalc = calculateSALHierarchical(this.state.salList);
        
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"SAL- " + this.state.data.nome}
                    backButton={this.props.backFunction}
                />
                {[ROLES.segreteria].includes(global.user.ruolo) || this.state.data.stato == "finito" ? null :
                    <MDButton variant="gradient" color="success" iconOnly onClick={() => this.createNewSAL()}>
                        <Icon>add</Icon>
                    </MDButton>
                }
                <Grid container mt={3}>
                    <Grid item sm={6}>
                        <MDTypography variant="h3" textTransform="uppercase">{this.state.data.nome}</MDTypography>
                    </Grid>
                    <Grid item sm={4} pl={2} pr={2} >
                        <MDTypography variant="label">Avanzamento Globale</MDTypography>
                        {this.renderProgressBar(globalCalc)}
                    </Grid>
                    <Grid item sm={2} pl={2} pr={2} >
                        <MDInput variant="outlined" key={"search"} placeholder={"Cerca"} onChange={(e) => { this.setState({ search: e.target.value }) }} defaultValue={""} />
                    </Grid>

                </Grid>

                <Grid mt={5}>
                    <Grid container>
                        <Grid item sm={1} >
                            <MDTypography variant="button">ID</MDTypography>
                        </Grid>

                        <Grid item sm={3} >
                            <MDTypography variant="button">Lavorazioni</MDTypography>
                        </Grid>

                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="button">Incidenza</MDTypography>
                        </Grid>

                        <Grid item sm={2} mr={1}>
                            <MDTypography variant="button">Percentuale di completamento</MDTypography>
                        </Grid>
                    </Grid>

                    {this.renderSALList(organizedForDisplay)}
                    
                    {/* Menu contestuale */}
                    <Menu
                        open={this.state.contextMenu !== null}
                        onClose={this.handleCloseContextMenu}
                        anchorReference="anchorPosition"
                        anchorPosition={
                            this.state.contextMenu !== null
                                ? { top: this.state.contextMenu.mouseY, left: this.state.contextMenu.mouseX }
                                : undefined
                        }
                    >
                        <MenuItem onClick={this.moveUp}>
                            <ListItemIcon>
                                <Icon fontSize="small">keyboard_arrow_up</Icon>
                            </ListItemIcon>
                            <ListItemText>Sposta in su</ListItemText>
                        </MenuItem>
                        
                        <MenuItem onClick={this.moveDown}>
                            <ListItemIcon>
                                <Icon fontSize="small">keyboard_arrow_down</Icon>
                            </ListItemIcon>
                            <ListItemText>Sposta in giù</ListItemText>
                        </MenuItem>
                        
                        <MenuItem onClick={this.moveToTop}>
                            <ListItemIcon>
                                <Icon fontSize="small">keyboard_double_arrow_up</Icon>
                            </ListItemIcon>
                            <ListItemText>Sposta in cima</ListItemText>
                        </MenuItem>
                        
                        <MenuItem onClick={this.moveToBottom}>
                            <ListItemIcon>
                                <Icon fontSize="small">keyboard_double_arrow_down</Icon>
                            </ListItemIcon>
                            <ListItemText>Sposta in fondo</ListItemText>
                        </MenuItem>
                        
                        {this.state.selectedSAL && this.state.selectedSAL.parent && (
                            <MenuItem onClick={this.increaseLevel}>
                                <ListItemIcon>
                                    <Icon fontSize="small">subdirectory_arrow_left</Icon>
                                </ListItemIcon>
                                <ListItemText>Aumenta di livello</ListItemText>
                            </MenuItem>
                        )}
                    </Menu>
                </Grid>
            </DashboardLayout>
        )
    }
}


